"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TextTranslate;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _LanguageContext = require("./LanguageContext");

var _LanguageDictionary = require("./LanguageDictionary");

var _LanguageDictionary2 = _interopRequireDefault(_LanguageDictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TextTranslate(_ref) {
    var text = _ref.text,
        _ref$isLowerCase = _ref.isLowerCase,
        isLowerCase = _ref$isLowerCase === undefined ? false : _ref$isLowerCase;

    var languageContext = (0, _react.useContext)(_LanguageContext.LanguageContext);
    if (text === undefined) {
        return null;
    }
    if (_react2.default.isValidElement(text)) {
        return text;
    }
    var newText = "";
    if (!languageContext.userLanguage) {
        newText = _lodash2.default.get(_LanguageDictionary2.default, _LanguageDictionary2.default.userLanguage + "." + text) || text;
    } else {
        newText = _LanguageDictionary2.default[languageContext.userLanguage][text] || text;
    }

    return isLowerCase ? newText.toLowerCase() : newText;
}